const defaults = {
  moduleSelector: '[data-stacked-cards]',
};

export default class StackedCards {
  constructor(settings = {}) {
    this.settings = { ...defaults, ...settings };
  }

  init() {
    const $modules = [...document.querySelectorAll(this.settings.moduleSelector)];

    if ($modules.length === 0) {
      return this;
    }

    $modules.forEach(($module) => {
      this.initModule($module);
    });

    return this;
  }

  initModule($module) {
    const $stickies = [].slice.call($module.querySelectorAll('.card'));

    $stickies.forEach(($sticky) => {
      $sticky.style.setProperty('--stacked-cards-card-index', (Array.from($sticky.parentNode.children).indexOf($sticky) + 1));
    });

    this.setVariables();

    window.addEventListener('resize', () => {
      this.setVariables();
    });

    if (CSS && CSS.supports && CSS.supports('animation-timeline: auto')) {
      // Do nothing...
    } else {
      this.applyStickies($module);

      window.addEventListener('scroll', () => {
        this.applyStickies($module);
      });
    }

    return this;
  }

  applyStickies($module) {
    // const $module = document.querySelector('[data-stacked-cards]');
    const $stickies = [].slice.call($module.querySelectorAll('.card'));

    $stickies.forEach(($sticky) => {
      if (CSS.supports && CSS.supports('position', 'sticky')) {
        this.applyStickyClass($sticky);
      }
    });

    return this;
  }

  applyStickyClass($sticky) {
    const currentOffset = $sticky.getBoundingClientRect().top;
    const stickyOffset = parseInt(getComputedStyle($sticky).top.replace('px', ''), 10);
    const isStuck = currentOffset <= stickyOffset;

    $sticky.classList.toggle('-is-sticky', isStuck);

    return this;
  }

  setVariables() {
    const cardHeight = document.querySelector('.stacked-cards-item').offsetHeight;

    document.documentElement.style.setProperty('--stacked-cards-card-height', `${cardHeight}px`);

    return this;
  }
}
